<template>
  <v-menu
      v-model="show"
      bottom
      left
      nudge-bottom="50"
      nudge-left="300"
      close-on-click
      :close-on-content-click="false"
      min-width="450px"
  >
    <template #activator="{on, attrs}">
      <v-btn
          icon
          v-on="on"
          v-bind="attrs"
          @click=" show= !show"
      >
        <v-icon size="24" color="info">
          mdi-phone-outline
        </v-icon>
      </v-btn>
    </template>
    <v-card class="contact-menu-card">
      <v-btn class="close-click" icon @click="show = false">
        <v-icon size="24" color="primary">mdi-close</v-icon>
      </v-btn>
      <template v-if="!loading">
        <v-card-title>
          <slot name="header-title">
            <h3>

            </h3>
          </slot>
          <slot name="header-subtitle">

          </slot>
        </v-card-title>
        <v-card-text
            class="d-flex flex-column"
        >
          <div class="font-weight-600 main-color">Представитель:</div>
          <div class="font-weight-600">{{ contact.fio }}</div>
          <div>{{ contact.position }}</div>
          <div class="mt-5">Рабочий телефон: <span class="font-weight-600">{{ contact.workPhoneNumber }}</span></div>
          <div>Мобильный телефон: <span class="font-weight-600">{{ contact.personalPhoneNumber }}</span></div>
          <div>Электронная почта: <span class="main-color font-weight-600">{{ contact.email }}</span></div>
          <div class="font-weight-600 main-color mt-3">Ответственный:</div>
          <div class="font-weight-600">{{ contactOne.fio }}</div>
          <div>{{ contactOne.position }}</div>
          <div class="mt-5">Рабочий телефон: <span class="font-weight-600">{{ contactOne.workPhoneNumber }}</span></div>
          <div>Мобильный телефон: <span class="font-weight-600">{{ contactOne.personalPhoneNumber }}</span></div>
          <div>Электронная почта: <span class="main-color font-weight-600">{{ contactOne.email }}</span></div>
        </v-card-text>
      </template>
      <v-card-text v-else class="justify-center align-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import ContactsController from "@/controllers/ContactsController";

export default {
  name: "contact-menu",
  props: {
    typeContact: {
      type: String,
      default: 'founder',
      validator: (v) => {
        return ['region', 'founder','organization'].includes(v)
      },
    },
    propsContact: {
      type: [Object, Array],
      default: null
    },
    id: {
      type: Number,
      required: true,
      default: 0,
      validator: (v) => {
        return +v > 0
      },
    }
  },
  data() {
    return {
      show: false,
      loading: false,
      contact: {
        email: '',
        fio: "",
        position: "",
        workPhoneNumber: null,
        personalPhoneNumber: null,
        typeContact: 'MAIN'
      },
      contactOne:
          {
            email: '',
            fio: "",
            position: "",
            workPhoneNumber: null,
            personalPhoneNumber: null,
            typeContact: 'OTV'
          },
    }
  },
  watch: {
    show(newValue) {
      if (newValue)
        this.getServerInfo()
    }
  },
  methods: {
    async getServerInfo() {
      this.loading = true;
      // try{
      if (!this.propsContact.length) {
        if (this.typeContact !== 'organization')
        await ContactsController.getContact(this.typeContact, this.id)
            .then(data => {
              if (data && data.length > 0) {
                const contact = data.find(el => el.typeContact === 'MAIN');
                const contactOne = data.find(el => el.typeContact === 'OTV');
                for (const key of Object.keys(this.contact)) {
                  if (contact)
                    this.contact[key] = contact[key];
                  if (contactOne)
                    this.contactOne[key] = contactOne[key];
                }
                if (contact)
                  this.contact.id = contact.id;
                if (contactOne)
                  this.contactOne.id = contactOne.id;
              }
            }).catch(() => this.loading = false).finally(() => this.loading = false)
        else
          await ContactsController.getOrganizationContact(this.id)
              .then(data => {
                if (data && data.length > 0) {
                  const contact = data.find(el => el.typeContact === 'MAIN');
                  const contactOne = data.find(el => el.typeContact === 'OTV');
                  for (const key of Object.keys(this.contact)) {
                    if (contact)
                    {
                      if (key === 'fio')
                        this.contact[key] = `${contact.firstName} ${contact.lastName} ${contact.secondName}` ;
                      else
                        this.contact[key] = contact[key];
                    }
                    if (contactOne)
                    {
                      if (key === 'fio')
                        this.contactOne[key] = `${contactOne.firstName} ${contactOne.lastName} ${contactOne.secondName}` ;
                      else
                        this.contactOne[key] = contactOne[key];
                    }
                  }
                  if (contact)
                    this.contact.id = contact.id;
                  if (contactOne)
                    this.contactOne.id = contactOne.id;
                }
              }).catch(() => this.loading = false).finally(() => this.loading = false)
      }
      else{
        const contact = this.propsContact.find(el => el.typeContact === 'MAIN');
        const contactOne = this.propsContact.find(el => el.typeContact === 'OTV');
        for (const key of Object.keys(this.contact)) {
          if (contact)
          this.contact[key] = contact[key];
          if (contactOne)
            this.contactOne[key] = contactOne[key];
        }
        if (contact)
          this.contact.id = contact.id;
        if (contactOne)
          this.contactOne.id = contactOne.id;
        this.loading = false
      }
      // }catch (e){
      //   this.loading = false
      // }

    }

  },
}
</script>

<style scoped>

</style>